import React from 'react'
import StudentDetails from '../StudentDetails/StudentDetails'

const Profiles = () => {

  return (
    <div>
        <div className="container bg-stone-200 h-screen">
          <h2 className="text-black text-center text-4xl">
            Will do Crud Operation
          </h2>
          <StudentDetails></StudentDetails>
        </div>
    </div>
  )
}

export default Profiles
